angular.module("appVersion", [])
.constant("version", "4.57.2026021-8.2");
